export default {
    updateError(state, payload) {
        state.error = payload
    },
    updateFayeSetup(state, payload) {
        state.faye = Object.assign(state.faye, payload)
    },
    updateFayeClient(state, payload) {
        state.faye = Object.assign(state.faye, { client: payload })
    },
    updateFayeResult(state, payload) {
        state.faye = Object.assign(state.faye, { result: payload })
    },
    updateRenovationSeguradoras(state, payload) {
        state.seguradoras = payload
    },
    setQuotationId(state, payload) {
        state.quotationId = payload
    },
    setQuotation(state, payload) {
        state.quotation = payload
    },
    lastQuotationSaved(state, payload) {
        state.lastQuotationSaved = payload
    },
    setAutomationBearer(state, payload) {
        state.automationBearer = payload
    },
    addNewSelect(state, payload) {
        if (state.newSelects) {
            if (state.newSelects.some(s => s.name == payload.name)) {
                let index = state.newSelects.findIndex(f => f.name === payload.name)
                state.newSelects[index] = payload
            }
            else
                state.newSelects.push(payload)
        }
        else {
            state.newSelects = []
            state.newSelects.push(payload)
        }
    },
    setEnterpriseInsurers(state, payload){
        state.enterpriseInsurers = payload
    }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/vuex/mutations.js